
import Hero from './Hero/Hero';
import Programs from './Programs/Programs';
import Reasons from './Reasons/Reasons';
import Plans from './Plans/Plans';
import Testimonials from './Testimonials/Testimonials';

import Footer from './Footer/Footer';


import './App.css';



function App() {
 

  return (
    <frameElement>
      <Hero />
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Footer />
    </frameElement>
    
  );
}

export default App;
